export default "__VITE_ASSET__rrh_S8rh__"